import React, { Fragment, useState, useEffect, useMemo } from 'react';
import { Tooltip } from "reactstrap";

const InitialsAvatar = ({ name, id, userColor, dimensions, marginBottom }) => {
    const parts = name.split(' ');
    let initials = '';
    if (parts.length === 1) {
        initials = parts[0].substring(0, 2).toUpperCase();
    } else if (parts.length >= 2) {
        initials = parts[0].charAt(0).toUpperCase() + parts[1].charAt(0).toUpperCase();
    }
    // Generate a random background color when the component is mounted(useMemo will cache the result of a calculation between re-renders)
    const backgroundColor = useMemo(() => {
        return "#" + Math.floor(Math.random() * 16777215).toString(16);
    }, []);

    const [hover, setHover] = useState(false);

    return (
        <Fragment>
            <div
                id={id}
                style={{
                    backgroundColor: userColor,
                    color: "#FFFFFF",
                    width: dimensions,
                    height: dimensions,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: marginBottom || "20px"
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                {initials}
            </div>
            <Tooltip
                placement="top"
                isOpen={hover}
                target={id}
                toggle={() => {
                    setHover(!hover);
                }}
            >
                {name}
            </Tooltip>
        </Fragment>
    );
}

InitialsAvatar.defaultProps = {
    name: "OnCall Engineer",
    userColor: "#9F3D69",
}

export default InitialsAvatar;